import { render, staticRenderFns } from "./AffiliateBonusesModal.vue?vue&type=template&id=ae5389ae"
import script from "./AffiliateBonusesModal.vue?vue&type=script&lang=js"
export * from "./AffiliateBonusesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports